import type { RouteRecordRaw } from 'vue-router'

/**
 * Nota: la ruta `/login` ya está registrada en `router/routes.ts` (builtin)
 * para que el guard pueda hacer `next({ name: 'login' })` antes incluso de
 * cargar este módulo. Aquí solo exponemos rutas adicionales del módulo.
 */
const routes: RouteRecordRaw[] = []

export default routes
